module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "ui",
    class: [{
      'dimmable': _vm.screenWidth > 768,
      'dimmed': _vm.hovered
    }],
    on: {
      "mouseover": function($event) {
        _vm.hovered = true
      },
      "mouseleave": function($event) {
        _vm.hovered = false
      },
      "click": _vm.select
    }
  }, [_c('div', {
    staticClass: "ui simple responsive dimmer",
    class: {
      'red': _vm.expired || _vm.disabled
    }
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.disabled) ? _c('div', {
    staticClass: "center"
  }, [_vm._v("\n        Not Available\n      ")]) : (_vm.expired) ? _c('div', {
    staticClass: "center"
  }, [_vm._v("\n        Too Late\n      ")]) : _c('div', {
    staticClass: "center"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.boat.name))])]), _vm._v(" "), (!_vm.boat.startsAtHalfHour) ? _c('p', [_vm._v(_vm._s(_vm.hour) + " Uhr")]) : _c('p', [_vm._v("\n          " + _vm._s((parseInt(_vm.hour.split(' - ')[0]) - 1) + ':30') + " - " + _vm._s((parseInt(_vm.hour.split(' - ')[1]) - 1) + ':30') + "\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "booking-field",
    class: [_vm.booking.status, {
      'expired': _vm.expired
    }, {
      'disabled': _vm.disabled
    }, {
      'my': _vm.booking.clientId === this.clientId
    }]
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d7d7f72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BookingChoice.vue
// module id = 741
// module chunks = 1